/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/camper_trailer'
export default icon
